// Clients
export const GET_CLIENTS = 'GET_CLIENTS';

// Content
export const SET_FETCHED_CONTENT = 'SET_FETCHED_CONTENT';
export const PROCESS_CONTENT_ACTION = 'PROCESS_CONTENT_ACTION';
export const FETCH_PARENT = 'FETCH_PARENT';
export const FETCH_CONTENT_HISTORY = 'FETCH_CONTENT_HISTORY';
export const REVIEW_CONTENT = 'REVIEW_CONTENT';
export const SUBMIT_EDITOR_PICK = 'SUBMIT_EDITOR_PICK';
export const TOP_COMMENTS_EXCLUDE = 'TOP_COMMENTS_EXCLUDE';
export const TOP_COMMENTS_REINCLUDE = 'TOP_COMMENTS_REINCLUDE';
export const ADD_CONTENT_ACTION = 'ADD_CONTENT_ACTION';
export const SEND_ANALYTICS_CONTENT_EVENT = 'SEND_ANALYTICS_CONTENT_EVENT';

// Follows
export const FETCH_FOLLOWING_DATA = 'FETCH_FOLLOWING_DATA';
// TODO: TEMPORARILY still using PHP until Tyrion is ready (CM-176)
export const FETCH_REMAINDER_USER_INFO = 'FETCH_REMAINDER_USER_INFO';

// Language
export const LOAD_ASYNC_LANGUAGE = 'LOAD_ASYNC_LANGUAGE';

// Page
export const FETCH_PAGE_BY_UUID = 'FETCH_PAGE_BY_UUID';

// Queue
export const CREATE_QUEUE = 'CREATE_QUEUE';
export const FETCH_QUEUE = 'FETCH_QUEUE';
export const RENAME_QUEUE = 'RENAME_QUEUE';
export const EDIT_QUEUE = 'EDIT_QUEUE';
export const DELETE_QUEUE = 'DELETE_QUEUE';
export const DELETE_BATCH = 'DELETE_BATCH';
export const UPDATE_QUEUE = 'UPDATE_QUEUE';
export const BATCH_IS_ACTIVE = 'BATCH_IS_ACTIVE';

// Search
export const CREATE_SEARCH = 'CREATE_SEARCH';
export const FETCH_SEARCH = 'FETCH_SEARCH';
export const RENAME_SEARCH = 'RENAME_SEARCH';
export const DELETE_SEARCH = 'DELETE_SEARCH';
export const UPDATE_SEARCH = 'UPDATE_SEARCH';
export const FETCH_QUICK_SEARCH = 'FETCH_QUICK_SEARCH';
export const EXPORT_SEARCH = 'EXPORT_SEARCH';
export const EXPORT_QUICK_SEARCH = 'EXPORT_QUICK_SEARCH';

// Sites
export const FETCH_ACTIVE_SITE = 'FETCH_ACTIVE_SITE';

// Users
export const DELETE_USER = 'DELETE_USER';
export const TRUST_USER = 'TRUST_USER';
export const PROMOTE_USER = 'PROMOTE_USER';
export const REJECT_AVATAR = 'REJECT_AVATAR';
export const REJECT_NAME = 'REJECT_NAME';
export const FETCH_USERS_RECENT_CONTENT = 'FETCH_USERS_RECENT_CONTENT';
export const FETCH_USER_BY_UUID = 'FETCH_USER_BY_UUID';
export const FETCH_USER_BY_UUID_WITHOUT_SITE = 'FETCH_USER_BY_UUID_WITHOUT_SITE';
export const FETCH_CURRENT_USER = 'FETCH_CURRENT_USER';
export const REGISTER_USER = 'REGISTER_USER';

// Workspaces
export const CREATE_WORKSPACE = 'CREATE_WORKSPACE';
export const RENAME_WORKSPACE = 'RENAME_WORKSPACE';
export const SET_WORKSPACE_ACCESS = 'SET_WORKSPACE_ACCESS';
export const FETCH_WORKSPACES = 'FETCH_WORKSPACES';
export const FETCH_WORKSPACE = 'FETCH_WORKSPACE';
export const DELETE_WORKSPACE = 'DELETE_WORKSPACE';
export const FETCH_WORKSPACES_INFORMATION = 'FETCH_WORKSPACES_INFORMATION';
export const DUPLICATE_WORKSPACE = 'DUPLICATE_WORKSPACE';

// Time
export const UPDATE_LAST_ACTIVE = 'UPDATE_LAST_ACTIVE';
export const INCREMENT_ATTENTION_TIME = 'INCREMENT_ATTENTION_TIME';
export const SEND_ATTENTION_TIME = 'SEND_ATTENTION_TIME';

// Version
export const GET_CONSOLE_VERSION = 'GET_CONSOLE_VERSION';
